import { FunctionComponent } from 'react'
import { Field as FormikField, FieldProps } from 'formik'
import { useTranslation } from 'react-i18next'
import { Field, Textarea } from '@matillion/component-library'

import classes from 'modules/Secrets/SecretDefinitionFormContent/SecretDefinitionFormContent.module.scss'
import {
  FormFields,
  resolveFormikError
} from 'modules/Secrets/CreateSecretDefinitionForm/CreateSecretDefinitionForm.utils'

const Description: FunctionComponent = () => {
  const { t } = useTranslation()

  return (
    <div data-testid="secret-definition-description">
      <FormikField name={FormFields.description}>
        {({ field, meta }: FieldProps<string>) => (
          <Field
            {...field}
            className={classes['SecretDefinitionFormContent__Field--normal']}
            title={t('secrets.definitionForm.fields.description.title')}
            placeholder={t(
              'secrets.definitionForm.fields.description.placeholder'
            )}
            inputComponent={Textarea}
            maxLength={256}
            errorText={resolveFormikError(t, meta)}
            data-testid="secret-definition-description-input"
          />
        )}
      </FormikField>
    </div>
  )
}

export default Description
